export default __webpack_public_path__ + "static/media/trust_icon.103f8409.svg";